import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * 창 width 변화를 감지해서 미디어쿼리 사이즈를 반환합니다.
 * @returns
 * currentScreenSize: 현재 미디어쿼리 사이즈,
 */
function useMediaQuery() {
  const $ = _c(4);
  const [currentScreenSize, setCurrentScreenSize] = useState("md");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mediaQuerySmall = window.matchMedia("(max-width: 1802px)");
      const mediaQueryLarge = window.matchMedia("(min-width: 1803px) and (max-width: 2000px) ");
      if (mediaQuerySmall.matches) {
        setCurrentScreenSize("md");
      } else {
        if (!mediaQuerySmall.matches && mediaQueryLarge.matches) {
          setCurrentScreenSize("lg");
        } else {
          setCurrentScreenSize("xl");
        }
      }
      const handleSmallMediaChange = e => {
        if (e.matches) {
          setCurrentScreenSize("md");
        } else {
          if (mediaQueryLarge.matches) {
            setCurrentScreenSize("lg");
            return;
          }
          setCurrentScreenSize("xl");
        }
      };
      const handleLargeMediaChange = e_0 => {
        if (e_0.matches) {
          setCurrentScreenSize("lg");
        } else {
          if (mediaQuerySmall.matches) {
            setCurrentScreenSize("md");
            return;
          }
          setCurrentScreenSize("xl");
        }
      };
      mediaQueryLarge.addEventListener("change", handleLargeMediaChange);
      mediaQuerySmall.addEventListener("change", handleSmallMediaChange);
      return () => {
        mediaQueryLarge.removeEventListener("change", handleLargeMediaChange);
        mediaQuerySmall.removeEventListener("change", handleSmallMediaChange);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== currentScreenSize) {
    t2 = {
      currentScreenSize
    };
    $[2] = currentScreenSize;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export default useMediaQuery;